module.exports = __webpack_public_path__ + "img/how_is_your_alignment.f9787b63.png";